import { getDevices } from 'src/utils/firebase/firebase-short-cut';
import useSWR from 'swr';

const useDevices = () => {
  const { data: devices } = useSWR('devices', getDevices);

  return {
    devices,
  };
};

export default useDevices;
